import { createContext, useContext, useReducer, useMemo } from 'react';

const ConsumerContext = createContext(null);

//used only in V3
export const useConsumer = () => {
  const ctx = useContext(ConsumerContext);
  if (!ctx) throw new Error('useConsumer doit être utilisé dans <ConsumerProvider>');
  return ctx;
};

const initialState = {
  brand: null,
  parcel: null,
  selectedPoint: null,
  fetchAlert: false,
  alertMessage: '',
};

//event pour mettre à jours les states du consumer (brand, point de retrait sélectionné, etc)
function reducer(state, action) {
  switch (action.type) {
    case 'CONSUMER_BRAND_LOADED':
      return { ...state, brand: action.brand, fetchAlert: false, alertMessage: '' };
    case 'CONSUMER_PARCEL_LOADED':
      return { ...state, parcel: action.parcel };
    case 'CONSUMER_POINT_SELECTED':
      return { ...state, selectedPoint: action.point };
    case 'CONSUMER_STATES_UPDATE':
      return { ...state, ...action.payload };
    case 'CONSUMER_RESET':
      return { ...initialState };
    case 'CONSUMER_RESET_KEEP_BRAND':
      return { ...initialState, brand: state.brand };
    default:
      return state;
  }
}

export function ConsumerProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = useMemo(() => ({ ...state, dispatch }), [state]);
  return (
    <ConsumerContext.Provider value={value}>
      {children}
    </ConsumerContext.Provider>
  );
}
